import type { AsyncDataOptions } from 'nuxt/app';

export function useCategoryList<T>(
    options?: AsyncDataOptions<T>
) {
    const fetchOptions = options ?? {
        params: {
            include: "children",
        },
    }
    return useLazyAsyncData<T>(
        "categories-list",
        () =>
            fetchLocal("/category/list", {
                ...fetchOptions
            }),
        {
            getCachedData(key, nuxtApp) {
                return nuxtApp.payload.data[key] || nuxtApp.static.data[key];
            },
        }
    );
}